// test2058
(2058 && 0);
